import { doPost } from "../api/baseAPI";

export const POSTGetListReportServices = async (token, api_contract, body) => {
  let result = { 
    success: false, 
    list: undefined, 
    errorCode: undefined, 
    message: undefined 
  }

  try {
    const response = await doPost(api_contract, token, body);
    if (response) {
      result.success = true;
      result.list = response?.data?.payload?.data;
      result.message = response?.data?.payload?.status?.message;
      delete result.errorCode;
    }
  } catch (error) {
    result.success = false;
    result.errorCode = error?.response?.data?.payload?.status;
    result.message = error?.response?.data?.payload?.message;
    delete result.list;
  }
return result
}